<template>
  <div class="client">
    <img
      :src="client.ClientLogo.File.Url"
      :alt="client.ClientName"
      class="client__logo-img"
    >
  </div>
</template>

<script>
export default {
  name: 'FeaturedClient',
  props: {
    client: { type: Object, default: null, reqquired: true }
  }
}
</script>

<style lang="scss" scoped>
.client {
  border: 1px solid #e5e5e5;
  padding: 0.25rem 0;
  margin-bottom: 1rem;

  &__logo-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentItems/FeaturedClient.vue